// MARCA-1: carrega a Barlow (400/500/600/700/800) só nas telas de Treinamentos/Desafio.
import { useEffect } from "react";

export default function useBarlow() {
  useEffect(() => {
    const id = "mpires-barlow-font";
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = "https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700;800&display=swap";
      document.head.appendChild(link);
    }
  }, []);
}
